module.exports = __webpack_public_path__ + "static/media/Flik3.0a6148d5.pdf";